import {
    USER_LOGIN_FAIL,
    USER_LOGIN_REQUEST,
    USER_LOGIN_SUCCESS,
    USER_LOGIN_RESET,
    USER_LOGOUT,
    USER_REGISTER_FAIL,
    USER_REGISTER_REQUEST,
    USER_REGISTER_SUCCESS,
    USER_REGISTER_RESET,
    USER_CONFIRM_REGISTER_REQUEST,
    USER_CONFIRM_REGISTER_SUCCESS,
    USER_CONFIRM_REGISTER_FAIL,
    USER_CREATE_PASSWORD_REQUEST,
    USER_CREATE_PASSWORD_SUCCESS,
    USER_CREATE_PASSWORD_FAIL,
    USER_RECOVERY_REQUEST,
    USER_RECOVERY_SUCCESS,
    USER_RECOVERY_FAIL,
    USER_RECOVERY_RESET,
    USER_PROFILE_INFORMATION_REQUEST,
    USER_PROFILE_INFORMATION_REQUEST_SUCCESS,
    USER_PROFILE_INFORMATION_REQUEST_FAIL,
    USER_UPDATE_PROFILE_REQUEST,
    USER_UPDATE_PROFILE_REQUEST_SUCCESS,
    USER_UPDATE_PROFILE_REQUEST_FAIL,
    USER_UPDATE_IMAGE_REQUEST,
    USER_UPDATE_IMAGE_SUCCESS,
    USER_UPDATE_IMAGE_FAIL,
    USER_ADD_BOOKMARCK_REQUEST,
    USER_ADD_BOOKMARCK_REQUEST_SUCCESS,
    USER_ADD_BOOKMARCK_REQUEST_FAIL,
    USER_REMOVE_BOOKMARCK_REQUEST,
    USER_REMOVE_BOOKMARCK_REQUEST_SUCCESS,
    USER_REMOVE_BOOKMARCK_REQUEST_FAIL,
    USER_UPDATE_PASSWORD_REQUEST,
    USER_UPDATE_PASSWORD_REQUEST_SUCCESS,
    USER_UPDATE_PASSWORD_REQUEST_FAIL,
    USER_LIST_OF_PAID_INVOICES_REQUEST,
    USER_LIST_OF_PAID_INVOICES_REQUEST_SUCCESS,
    USER_LIST_OF_PAID_INVOICES_REQUEST_FAIL,
    USER_LIST_OF_UNPAID_INVOICES_REQUEST,
    USER_LIST_OF_UNPAID_INVOICES_REQUEST_SUCCESS,
    USER_LIST_OF_UNPAID_INVOICES_REQUEST_FAIL,
} from "./userConstants";

export const paidInvoicesListReducer = (state = {
    paidInvoicesLoading: true,
    paidInvoicesError: '',
    paidInvoices: [],
    paidInvoicestotalPages: 0,
}, action) => {
    switch (action.type) {
        case USER_LIST_OF_PAID_INVOICES_REQUEST:
            return {
                paidInvoicesLoading: true,
                ...state
            }
        case USER_LIST_OF_PAID_INVOICES_REQUEST_SUCCESS:
            return {
                paidInvoicesLoading: false,
                paidInvoices: action.payload.invoices,
                paidInvoicestotalPages: action.payload.totalPages,
            }
        case USER_LIST_OF_PAID_INVOICES_REQUEST_FAIL:
            return { paidInvoicesLoading: false, paidInvoicesError: action.payload }
        default:
            return state
    }
}

export const unPaidInvoicesListReducer = (state = {
    unpaidInvoicesLoading: true,
    unpaidInvoicesError: '',
    unpaidInvoices: [],
    unpaidInvoicesTotalPages: 0,
}, action) => {
    switch (action.type) {
        case USER_LIST_OF_UNPAID_INVOICES_REQUEST:
            return {
                unpaidInvoicesLoading: true,
                ...state
            }
        case USER_LIST_OF_UNPAID_INVOICES_REQUEST_SUCCESS:
            return {
                unpaidInvoicesLoading: false,
                unpaidInvoices: action.payload.invoices,
                unpaidInvoicesTotalPages: action.payload.totalPages,
            }
        case USER_LIST_OF_UNPAID_INVOICES_REQUEST_FAIL:
            return { unpaidInvoicesLoading: false, unpaidInvoicesError: action.payload }
        default:
            return state
    }
}

export const userProfileInformationReducer = (state = {
    address: '',
    fullName: '',
    imageURL: null,
    mobileNumber: '',
}, action) => {
    switch (action.type) {
        case USER_PROFILE_INFORMATION_REQUEST:
            return {
                loading: true,
                ...state
            }
        case USER_PROFILE_INFORMATION_REQUEST_SUCCESS:
            return {
                loading: false,
                address: action.payload.address,
                fullName: action.payload.fullName,
                imageURL: action.payload.imageURL,
                mobileNumber: action.payload.mobileNumber,
            }
        case USER_PROFILE_INFORMATION_REQUEST_FAIL:
            return { loading: false, error: action.payload }
        default:
            return state
    }
}

export const userProfileUpdateReducer = (state = {
    status: false,
    message: '',
}, action) => {
    switch (action.type) {
        case USER_UPDATE_PROFILE_REQUEST:
            return {
                loading: true,
                ...state
            }
        case USER_UPDATE_PROFILE_REQUEST_SUCCESS:
            return {
                loading: false,
                message: action.payload.message,
                status: action.payload.status,
            }
        case USER_UPDATE_PROFILE_REQUEST_FAIL:
            return { loading: false, status: false, message: action.payload.message }
        default:
            return state
    }
}

export const userProfilePasswordUpdateReducer = (state = {
    status: false,
    message: '',
}, action) => {
    switch (action.type) {
        case USER_UPDATE_PASSWORD_REQUEST:
            return {
                loading: true,
                ...state
            }
        case USER_UPDATE_PASSWORD_REQUEST_SUCCESS:
            return {
                loading: false,
                message: action.payload.message,
                status: action.payload.status,
            }
        case USER_UPDATE_PASSWORD_REQUEST_FAIL:
            return { loading: false, status: false, message: action.payload.message }
        default:
            return state
    }
}

export const userProfileImageUpdateReducer = (state = {
    status: false,
    message: '',
}, action) => {
    switch (action.type) {
        case USER_UPDATE_IMAGE_REQUEST:
            return {
                loading: true,
                ...state
            }
        case USER_UPDATE_IMAGE_SUCCESS:
            return {
                loading: false,
                message: action.payload.message,
                status: action.payload.status,
            }
        case USER_UPDATE_IMAGE_FAIL:
            return { loading: false, status: false, message: action.payload.message }
        default:
            return state
    }
}

export const addBookmarkReducer = (state = {
    status: false,
    message: '',
}, action) => {
    switch (action.type) {
        case USER_ADD_BOOKMARCK_REQUEST:
            return {
                loading: true,
                ...state
            }
        case USER_ADD_BOOKMARCK_REQUEST_SUCCESS:
            return {
                loading: false,
                message: action.payload.message,
                status: action.payload.status,
            }
        case USER_ADD_BOOKMARCK_REQUEST_FAIL:
            return { loading: false, status: false, message: action.payload.message }
        default:
            return state
    }
}

export const removeBookmarkReducer = (state = {
    status: false,
    message: '',
}, action) => {
    switch (action.type) {
        case USER_REMOVE_BOOKMARCK_REQUEST:
            return {
                loading: true,
                ...state
            }
        case USER_REMOVE_BOOKMARCK_REQUEST_SUCCESS:
            return {
                loading: false,
                message: action.payload.message,
                status: action.payload.status,
            }
        case USER_REMOVE_BOOKMARCK_REQUEST_FAIL:
            return { loading: false, status: false, message: action.payload.message }
        default:
            return state
    }
}

export const userLoginReducer = (state = {}, action) => {
    switch (action.type) {
        case USER_LOGIN_REQUEST:
            return { loading: true };
        case USER_LOGIN_SUCCESS:
            return { loading: false, userInfo: action.payload };
        case USER_LOGIN_FAIL:
            return { loading: false, error: action.payload };
        case USER_LOGIN_RESET:
            return { loading: false, userInfo: null };
        case USER_LOGOUT:
            return {};
        default:
            return state;
    }
};

export const userRegisterReducer = (state = {}, action) => {
    switch (action.type) {
        case USER_REGISTER_REQUEST:
            return { loading: true };
        case USER_REGISTER_SUCCESS:
            return { loading: false, data: action.payload };
        case USER_REGISTER_RESET:
            return { loading: false, data: {} };
        case USER_REGISTER_FAIL:
            return { loading: false, error: action.payload };
        case USER_LOGOUT:
            return {};
        default:
            return state;
    }
};

export const userConfirmRegisterReducer = (state = {}, action) => {
    switch (action.type) {
        case USER_CONFIRM_REGISTER_REQUEST:
            return { loading: true };
        case USER_CONFIRM_REGISTER_SUCCESS:
            return { loading: false, confirmData: action.payload };
        case USER_CONFIRM_REGISTER_FAIL:
            return { loading: false, error: action.payload };
        default:
            return state;
    }
};

export const userCreatePasswordReducer = (state = {}, action) => {
    switch (action.type) {
        case USER_CREATE_PASSWORD_REQUEST:
            return { loading: true };
        case USER_CREATE_PASSWORD_SUCCESS:
            return { loading: false, userCreateData: action.payload };
        case USER_CREATE_PASSWORD_FAIL:
            return { loading: false, error: action.payload };
        default:
            return state;
    }
};

export const userRecoveyReducer = (state = {}, action) => {
    switch (action.type) {
        case USER_RECOVERY_REQUEST:
            return { loading: true };
        case USER_RECOVERY_SUCCESS:
            return { loading: false, recoveryData: action.payload };
        case USER_RECOVERY_FAIL:
            return { loading: false, error: action.payload };
        case USER_RECOVERY_RESET:
            return { loading: false, recoveryData: {} };

        default:
            return state;
    }
};
